import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Link from '@/components/base/Linker';
import Icon from '@/components/base/Icon';
import BlockHeightLink from '@/components/combined/BlockHeightLink';
import Tooltip from '@/components/base/Tooltip';
import IntervalTime from '@/components/combined/IntervalTime';
import { toDio, toShard, toToken } from '@/utils/string';
import { makeAddressInfo, makeShardDetailLink, makeTxDetailLink, makePendingTxDetailLink, makeDAppContract, makeTokenInfo, makeDAppAddress } from '@/utils/link';
import { gettext } from '@/utils/langsBook';
import getBlockService from '@/api/blocks';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import clss from 'classnames';
import NFTIDLink from '@/components/combined/NFTIDLink';
import AddressLink from '@/components/combined/AddressLink';
import classNames from 'classnames';
import { DEFAULT } from '.';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var blockService = getBlockService();
var TableItemStyled = styled.div.withConfig({
    displayName: "Transaction__TableItemStyled",
    componentId: "sc-133mow2-0"
})([
    "",
    " &.row{",
    "}p{",
    "}span,.desc{",
    "}.item-end{",
    " .icon{",
    "}}.diox-font{",
    "}.txn-type{",
    "}"
], {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "baseline"
}, {
    "flexDirection": "row",
    "alignItems": "center"
}, {
    "fontSize": "15px",
    "textAlign": "left"
}, {
    "fontSize": "13px",
    "color": "var(--color-desc-text)"
}, {
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "paddingRight": "50px",
    "justifyContent": "flex-end",
    "fontSize": "0px"
}, {
    "marginRight": "9px",
    "color": "var(--color-desc-text)",
    "fontSize": "16px"
}, {
    "fontSize": "16px"
}, {
    "width": "24px",
    "height": "24px",
    "color": "var(--color-desc-text)",
    "borderRadius": "9999px",
    "fontSize": "24px",
    "marginRight": "20px"
});
export var TXN_TYPE_ALL = 'All';
export var TXN_TYPE_TRANSFER = 'Activity';
export var TXN_TYPE_ISSUED = 'Issued';
export var TXN_TYPE_OTHER = 'Other';
export var TXN_TYPE_REWARD = 'Mined'; // export const TXN_TYPE_NORMAL = 'Normal'
export var TXN_PK_RELAY_GROUP = 'PK_RELAY_GROUP';
export var TRANSACTION_TYPE;
(function(TRANSACTION_TYPE) {
    TRANSACTION_TYPE["OutboundRelay"] = 'OutboundRelay';
    TRANSACTION_TYPE["DispatchedRelay"] = 'DispatchedRelay';
    TRANSACTION_TYPE["Deferred"] = 'DeferredRelay';
    TRANSACTION_TYPE["Scheduled"] = 'Scheduled';
    TRANSACTION_TYPE["UserInitiated"] = 'UserInitiated';
    TRANSACTION_TYPE["IntraRelay"] = 'IntraRelay';
    TRANSACTION_TYPE["InboundRelay"] = 'InboundRelay';
})(TRANSACTION_TYPE || (TRANSACTION_TYPE = {}));
export var TRANSACTION_FILTER_TYPE;
(function(TRANSACTION_FILTER_TYPE) {
    TRANSACTION_FILTER_TYPE["All"] = 'All Txns';
    TRANSACTION_FILTER_TYPE["Executed"] = 'Executed Txns';
    TRANSACTION_FILTER_TYPE["Emitted"] = 'Emitted Txns';
})(TRANSACTION_FILTER_TYPE || (TRANSACTION_FILTER_TYPE = {}));
export var TRANSACTION_STATUS_SUCCESS = 'IVKRET_SUCCESS';
export var TRANSACTION_RETURN_VALUE = {
    0: 'Success',
    // Execution success, otherwise any committed states and generated relay txns will be discarded.
    1: 'Unspecified',
    // error coode is not specified
    2: 'InsufficientFunds',
    // insufficient funds for gas payment.
    3: 'InsufficientGasRequired',
    // Gas supplied < minimum requirement of the gas, which is determined without execution
    4: 'RunOutOfGas',
    // Gas runs out before execution of the the contract function is completed
    5: 'AssertionFailed',
    // explicit assertion defined in contract code
    6: 'ExceptionThrown',
    // exception trigger implicitly like divide-by-zero, thrown from underlying libraries
    7: 'ExecutionEngineUnavailable',
    8: 'ContractUnavailable',
    9: 'ContractFunctionUnavailable',
    10: 'ContractFunctionDisallowed ',
    11: 'InvalidFunctionArgments ',
    12: 'NativeContractReturnsFalse ',
    // Blue Screen Error
    200: 'InternalError =',
    201: 'OutOfMemory =',
    202: 'LoadStateFailure =',
    203: 'SaveStateFailure ='
};
export var TRANSACTION_STATUS = {
    TXN_READY: 'Pending',
    TXN_CONFIRMED: 'Confirmed',
    TXN_FINALIZED: 'Finalized'
};
export function getColumns() {
    var column = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], showType = arguments.length > 1 ? arguments[1] : void 0, showReward = arguments.length > 2 ? arguments[2] : void 0;
    var router = useRouter();
    var isMaster = !column.length;
    var isInBlockInfo = router.pathname.match('/blockchain/blocks');
    return [
        {
            key: 'Hash',
            width: isMaster ? 170 : showType ? 190 : 156,
            className: isMaster ? '!pl-[24px]' : '',
            render: function(row) {
                var ref, ref1;
                var isPending = !(row === null || row === void 0 ? void 0 : row.Height);
                var txnHash = row.TxnHash + (row.RelayGroupIndex !== 255 ? ":".concat(row.RelayGroupIndex) : '');
                var detailLink = isPending ? makePendingTxDetailLink : makeTxDetailLink;
                return(/*#__PURE__*/ _jsxs(TableItemStyled, {
                    className: "row",
                    children: [
                        showType && /*#__PURE__*/ _jsx(Icon, {
                            type: TRANSACTION_TYPE[row.TxnType],
                            className: classNames({
                                '!mr-[10px]': isMaster
                            }, 'txn-type')
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col items-baseline",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ _jsx(Tooltip, {
                                        overlay: /*#__PURE__*/ _jsx("div", {
                                            className: "text-[13px] text-desc font-mono",
                                            children: txnHash
                                        }),
                                        placement: "top",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    className: "text-[15px] mb-[6px] leading-[18px]",
                                                    href: detailLink(txnHash),
                                                    text: txnHash,
                                                    isHash: true
                                                }),
                                                row.Invocation && !!Number((ref = row.Invocation) === null || ref === void 0 ? void 0 : (ref1 = ref.Return) === null || ref1 === void 0 ? void 0 : ref1[0]) && /*#__PURE__*/ _jsx(Icon, {
                                                    type: "state-error",
                                                    className: "text-[13px] ml-[8px]"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(IntervalTime, {
                                    className: "desc",
                                    time: row.BlockTime || row.TxnTime || 0
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ].concat(_toConsumableArray(column), [
        {
            key: 'Invocation',
            width: 'auto',
            className: isMaster ? '!pl-[10px]' : '',
            render: function(row) {
                var ref = row || {}, Func = ref.Func, Invocation = ref.Invocation, TokenSymbol = ref.TokenSymbol, TokenDecimals = ref.TokenDecimals, Contract = ref.Contract;
                var Input = Invocation === null || Invocation === void 0 ? void 0 : Invocation.Input;
                return(/*#__PURE__*/ _jsx(TableItemStyled, {
                    className: clss({
                        'pl-[318px]': isInBlockInfo
                    }),
                    children: Func.match(/transfer/) ? /*#__PURE__*/ _jsxs("div", {
                        className: "title flex items-center flex-wrap !font-normal",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-desc flex items-center !text-[15px]",
                                children: [
                                    "Transfer",
                                    ' ',
                                    TokenSymbol ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            toToken({
                                                value: (Input === null || Input === void 0 ? void 0 : Input.Amount) || (Input === null || Input === void 0 ? void 0 : Input.amount),
                                                decimals: TokenDecimals
                                            }),
                                            " ",
                                            /*#__PURE__*/ _jsx(Link, {
                                                href: makeTokenInfo(TokenSymbol),
                                                children: TokenSymbol
                                            })
                                        ]
                                    }) : (Input === null || Input === void 0 ? void 0 : Input.NonFungibleId) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            "NFT",
                                            /*#__PURE__*/ _jsx(NFTIDLink, {
                                                className: "text-[15px]",
                                                nftid: Input === null || Input === void 0 ? void 0 : Input.NonFungibleId
                                            })
                                        ]
                                    }) : toDio((Input === null || Input === void 0 ? void 0 : Input.Amount) || (Input === null || Input === void 0 ? void 0 : Input.amount), true, Number(DEFAULT.DECIMAL))
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mx-[12px]",
                                        children: "⟶"
                                    }),
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        overlay: /*#__PURE__*/ _jsx("div", {
                                            className: "text-[13px] text-desc font-mono",
                                            children: (Input === null || Input === void 0 ? void 0 : Input.To) || (Input === null || Input === void 0 ? void 0 : Input.to)
                                        }),
                                        placement: "top",
                                        children: /*#__PURE__*/ _jsx(AddressLink, {
                                            className: "text-[15px] leading-[18px]",
                                            address: (Input === null || Input === void 0 ? void 0 : Input.To) || (Input === null || Input === void 0 ? void 0 : Input.to)
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: clss({
                            'min-w-[283px] line-clamp max-w-[320px]': isMaster
                        }, 'overflow-hidden whitespace-nowrap text-ellipsis title text-desc'),
                        title: Func,
                        children: /*#__PURE__*/ _jsxs("span", {
                            className: "mr-[6px] text-desc !text-[15px]",
                            children: [
                                "Call",
                                ' ',
                                Contract.match(/^core./) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: makeDAppAddress('core:dapp'),
                                            children: "core"
                                        }),
                                        Func.replace('core', '')
                                    ]
                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: makeDAppContract(Contract.split('.')[0] + ':dapp', Contract),
                                            children: Contract
                                        }),
                                        Func.replace(Contract, '')
                                    ]
                                })
                            ]
                        })
                    })
                }));
            }
        },
        {
            key: 'Address',
            width: isMaster ? 180 : 305,
            align: 'right',
            className: clss({
                '!w-[180px]': isMaster
            }, '!pl-[0]'),
            render: function(row) {
                if (showReward) {
                    var ref, ref2;
                    return(/*#__PURE__*/ _jsx(TableItemStyled, {
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: clss({
                                '!pr-[148px]': !isMaster
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "reward",
                                    className: "icon"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-[15px]",
                                    children: toDio((((ref = row.Invocation) === null || ref === void 0 ? void 0 : (ref2 = ref.Input) === null || ref2 === void 0 ? void 0 : ref2.Reward) || '').split(':')[0], true)
                                })
                            ]
                        })
                    }));
                }
                var isTargetEqualInitiator = row.Target === row.Initiator;
                var ref3 = _slicedToArray((row.Target || '').split(':'), 2), symbol = ref3[0], type = ref3[1];
                var ref4 = _slicedToArray((row.Initiator || '').split(':'), 2), initiatorSymbol = ref4[0], initiatorType = ref4[1];
                var isToken = type === 'token';
                var isDApp = type === 'dapp';
                var isInitiatorToken = initiatorType === 'token';
                var isInitiatorDApp = initiatorType === 'dapp';
                return(/*#__PURE__*/ _jsxs(TableItemStyled, {
                    children: [
                        row.Target && /*#__PURE__*/ _jsxs("div", {
                            className: clss({
                                '!pr-[148px]': !isMaster
                            }, {
                                '!pr-[24px]': isMaster
                            }, 'item-end'),
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "aim",
                                    className: "icon"
                                }),
                                isTargetEqualInitiator && /*#__PURE__*/ _jsx(Icon, {
                                    type: "edit",
                                    className: "icon"
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    overlay: /*#__PURE__*/ _jsx("div", {
                                        className: "text-[13px] text-desc font-mono",
                                        children: row.Target
                                    }),
                                    placement: "top",
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        className: "text-[14px] leading-[16px]",
                                        href: isToken ? makeTokenInfo(row.Target.split(':')[0] + ':token') : isDApp ? makeDAppAddress(row.Target.split(':')[0] + ':dapp') : makeAddressInfo(row.Target),
                                        text: row.Target,
                                        isAddress: true,
                                        isToken: isToken,
                                        isDApp: isDApp
                                    })
                                })
                            ]
                        }),
                        row.OriginalTxnHash ? /*#__PURE__*/ _jsxs("div", {
                            className: clss({
                                '!pr-[148px]': !isMaster
                            }, {
                                '!pr-[24px]': isMaster
                            }, 'item-end mt-[6px]'),
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "ortxn",
                                    className: "icon"
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    overlay: /*#__PURE__*/ _jsx("div", {
                                        className: "text-[13px] text-desc font-mono",
                                        children: row.OriginalTxnHash
                                    }),
                                    placement: "top",
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        className: "text-[14px] leading-[16px]",
                                        href: makeTxDetailLink(row.OriginalTxnHash),
                                        text: row.OriginalTxnHash,
                                        isHash: true
                                    })
                                })
                            ]
                        }) : row.Initiator && !isTargetEqualInitiator ? /*#__PURE__*/ _jsxs("div", {
                            className: clss({
                                '!pr-[148px]': !isMaster
                            }, {
                                '!pr-[24px]': isMaster
                            }, 'item-end mt-[6px]'),
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "edit",
                                    className: "icon"
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    overlay: /*#__PURE__*/ _jsx("div", {
                                        className: "text-[13px] text-desc font-mono",
                                        children: row.Initiator
                                    }),
                                    placement: "top",
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        className: "text-[14px] leading-[16px]",
                                        href: makeAddressInfo(row.Initiator),
                                        text: row.Initiator,
                                        isAddress: true,
                                        isToken: isInitiatorToken,
                                        isDApp: isInitiatorDApp
                                    })
                                })
                            ]
                        }) : ''
                    ]
                }));
            }
        }
    ]);
}
export var getPendingTransactionsColumns = function() {
    var showType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return getColumns([
        {
            key: 'Shard',
            width: 200,
            render: function(row) {
                /*#__PURE__*/ return _jsx(TableItemStyled, {
                    className: "pl-[40px]",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center desc mb-[6px]",
                        children: [
                            gettext('Shard'),
                            /*#__PURE__*/ _jsx(Link, {
                                className: "text-[13px]",
                                href: makeShardDetailLink(row.ShardIndex),
                                text: toShard(row.ShardIndex)
                            })
                        ]
                    })
                });
            }
        }
    ], showType);
};
export var getTransactionsColumns = function() {
    var showType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, showReward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getColumns([
        {
            key: 'Height',
            width: 200,
            render: function(row) {
                /*#__PURE__*/ return _jsxs(TableItemStyled, {
                    className: "pl-[40px]",
                    children: [
                        /*#__PURE__*/ _jsx(BlockHeightLink, {
                            height: row.Height,
                            shardIndex: row.ShardIndex
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center desc !text-[15px]",
                            children: [
                                gettext('Shard'),
                                /*#__PURE__*/ _jsx(Link, {
                                    className: "text-[15px]",
                                    href: makeShardDetailLink(row.ShardIndex),
                                    text: toShard(row.ShardIndex)
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ], showType, showReward);
};
export var getTargetAddressByTxnDetail = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(txData) {
        var newAddress, mode, modeArr, ref, ref5, ref6, respone;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (txData) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", '');
                case 2:
                    newAddress = '';
                    mode = txData.Mode || '';
                    modeArr = mode.split('|');
                    if (!modeArr.includes('ITM_FIRST_SIGNER')) {
                        _ctx.next = 9;
                        break;
                    }
                    {
                        ;
                        newAddress = txData.Signers ? (ref = txData.Signers) === null || ref === void 0 ? void 0 : ref[0] : '';
                    }
                    _ctx.next = 18;
                    break;
                case 9:
                    if (!(modeArr.includes('ITM_MINER') && (txData === null || txData === void 0 ? void 0 : txData.ConfirmedBy))) {
                        _ctx.next = 17;
                        break;
                    }
                    ;
                    _ctx.next = 13;
                    return blockService.getBlockDetail(txData === null || txData === void 0 ? void 0 : txData.ConfirmedBy.split(':')[0]);
                case 13:
                    respone = _ctx.sent;
                    newAddress = (respone === null || respone === void 0 ? void 0 : (ref5 = respone.Result) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Content) === null || ref6 === void 0 ? void 0 : ref6.Miner) || '';
                    _ctx.next = 18;
                    break;
                case 17:
                    if (modeArr.includes('ITM_PERADDRESS')) {
                        newAddress = txData.Address;
                    } else if (modeArr.includes('TGM_RELAY') && txData.Target) {
                        newAddress = txData.Target;
                    }
                case 18:
                    return _ctx.abrupt("return", newAddress);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTargetAddressByTxnDetail(txData) {
        return _ref.apply(this, arguments);
    };
}();
